
export type NameTypeField = 'name_laqab' | 'name_kunya' | 'name_ism' | 'name_nasab' | 'name_nisba';
export type NameTypeLabel = 'Laqab' | 'Kunya' | 'Ism' | 'Nasab' | 'Nisba';

export interface NameType {
    field: NameTypeField;
    label: NameTypeLabel;
}

export const NAME_TYPES: Array<NameType> = [
    {'field': 'name_laqab', 'label': 'Laqab'},
    {'field': 'name_kunya', 'label': 'Kunya'},
    {'field': 'name_ism', 'label': 'Ism'},
    {'field': 'name_nasab', 'label': 'Nasab'},
    {'field': 'name_nisba', 'label': 'Nisba'}
];

export interface NameElement {
    '@url'?: string;
    name: string;
    name_laqab: string;
    name_kunya: string;
    name_ism: string;
    name_nasab: string;
    name_nisba: string;
    comments?: string;
    fkidmanuscripts?: number;
    __countMss?: number;
}

export type NameList = Array<NameElement>;

export class NameListFilters {
    private _orderBy: NameTypeField = null;
    private _containsText = '';

    set orderBy(value: NameTypeField) {
        this._orderBy = value;
    }

    get orderBy(): NameTypeField {
        return this._orderBy;
    }

    set containsText(value: string) {
        this._containsText = value;
    }

    get containsText(): string {
        return this._containsText;
    }

    isNull(): boolean {
        return this._orderBy === null
            && this._containsText === '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/name-list.ts